import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-1 rounded-md border border-gray-200 p-1" }
const _hoisted_2 = ["aria-pressed", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.filters, (filter) => {
      return _createElementVNode("button", {
        key: filter.value ?? 'all',
        type: "button",
        "aria-pressed": $props.modelValue.health === filter.value,
        class: _normalizeClass(["rounded px-3 py-1.5 text-xs transition-colors", 
                $props.modelValue.health === filter.value
                    ? 'bg-primary text-white'
                    : 'text-gray-500 hover:bg-gray-200'
            ]),
        onClick: ($event: any) => ($setup.selectFilter(filter.value))
      }, _toDisplayString(filter.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
    }), 64 /* STABLE_FRAGMENT */))
  ]))
}